<template>
  <v-row no-gutters style="padding: 0 15px">
    <div class="title-overlay">Under Development</div>
    <div class="blur">
      <ScavengerReportHeading
        :platform="platform"
        :tenant="tenant"
        :report_date="report_date"
        :report_time="report_time"
        :final_recepient="final_recepient"
        :recipients_number="recipients_number"
        report_period="weekly"
        :report_beginning_date="report_beginning_date"
      />
      <v-col cols="12" class="ml-3">
        <v-row no-gutters>
          <v-col v-if="device_details" cols="12">
            <v-row no-gutters class="mb-2">
              <v-col cols="12" class="text-subtitle-1"> Transformer Details </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col v-for="(item, index) in config.transformer_details" :key="index" cols="12">
                <v-row>
                  <v-col cols="4" class="font-weight-bold">{{ item.label }}</v-col>
                  <v-col cols="8">{{ device_details[item.value] }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-3" no-gutters>
          <v-col cols="4">
            <span class="text-subtitle-1"> Select Measurement Interval </span>
          </v-col>
          <v-col cols="8">
            <v-slider
              v-model="measurement_interval"
              :tick-labels="intervals.map((item) => item.label)"
              @change="get_report_data"
              :disabled="is_loading"
              :max="2"
              step="1"
              ticks="always"
              tick-size="4"
            ></v-slider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mb-3">
            <span class="text-subtitle-1">Compliance Summary</span>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" class="text-subtitle-1">EN50160 Evaluation</v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="12" class="text-subtitle-2">EN50160 Limits</v-col>
                <v-col cols="12"> </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="text-subtitle-2">Voltagae Dips</v-col>
                <v-col cols="12"> </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="text-subtitle-2">Short and Long Interruptions</v-col>
                <v-col cols="12"> </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="text-subtitle-2">Temporary Overvoltage</v-col>
                <v-col cols="12"> </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </div>
  </v-row>
</template>

<script>
import ScavengerReportHeading from "./ScavengerReportHeading.vue";
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";
import { tracking } from "../services/tracking";
import { content } from "../../config/assets.js";
import { content as reports_config } from "../../config/scavenger_reports.js";
import { scavenger_grpc_services } from "../services/ScavengerServices";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "ScavengerIEC61000Report",
  components: {
    ScavengerReportHeading,
  },
  props: {
    device_id: String,
  },
  watch: {},
  data: function () {
    return {
      tenant: "",
      recepient: "",
      report_time: "",
      report_start_date: "",
      report_beginning_date: "",
      report_end_date: "",
      report_date: "",
      snackbar: false,
      network_error: false,
      search_term: "",
      error_message: "",
      total_assets: 0,
      total_assets_known: 0,
      total_assets_unknown: 0,
      perc_assets_known: 0,
      perc_assets_unknown: 0,
      value_missing_assets: 0,
      dialog: false,
      message: "",
      overview_data: null,
      current_list: "all",
      location_data: {},
      recipients_list: null,
      config: null,
      device_details: null,
      measurement_interval: null,
      intervals: null,
      is_loading: false,
      platform: null,
    };
  },
  created() {
    this.page_content = content;
    this.config = reports_config.en61000_report;
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.recepient = this.$auth.user.email;
    this.intervals = reports_config.en61000_intervals;
    this.platform = this.tenant == "h2scan" ? "Sentinel" : "VT Electron";

    this.format_today_date();
    this.format_last_week_start();
    this.format_current_time();

    // Set the default measurement interval to 2 hours
    this.measurement_interval = this.intervals[2].value;
    // Get the report data for the default measurement interval (2 hours)
    this.get_report_data(2);
  },
  mounted() {
    if (this.$route.name == "Report_Snapshot") this.get_recipients_list();
    // this.$store.commit("update_page_title", "Report");

    this.get_device_details();
  },
  methods: {
    get_report_data(interval) {
      this.is_loading = true;
      // Report will be generated for the requested interval
      const interval_value = this.intervals[interval].value;
      //console.log("Making the call for interval: ", interval_value, "ms");
      // Make API calls to get the data for the requested interval
      // Multiple API call will be here

      // Set the loading to false once the data is received
      setInterval(() => {
        this.is_loading = false;
      }, 2000);
    },
    async get_device_details() {
      this.network_error = false;
      // const response = await axios_get(scv.get_scavenger_data, { id: this.device_id });
      const response = await scavenger_grpc_services.GetScavengerData(this.device_id);
      this.device_details = response[0];
      this.format_device_details();
    },
    async get_recipients_list() {
      this.network_error = false;
      const response = await axios_get(tracking.get_report_recipients_list, { id: 1 });
      this.recipients_list = response[0];
    },
    sort(s) {
      if (s === this.current_sort) {
        this.current_sort_dir = this.current_sort_dir === "asc" ? "desc" : "asc";
      }
      this.current_sort = s;
    },
    format_today_date() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      this.report_date = `${day}/${month}/${year}`;
      this.report_start_date = today.getTime();
    },
    format_last_week_start() {
      const today = new Date();
      const lastWeekStart = new Date(today);
      lastWeekStart.setDate(today.getDate() - 7);

      const day = String(lastWeekStart.getDate()).padStart(2, "0");
      const month = String(lastWeekStart.getMonth() + 1).padStart(2, "0");
      const year = lastWeekStart.getFullYear();
      this.report_beginning_date = `${day}/${month}/${year}`;
      this.report_end_date = lastWeekStart.getTime();
    },
    format_current_time() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      this.report_time = `${hours}:${minutes}:${seconds}`;
    },
    get_active_feeders(active_feeders) {
      return active_feeders.toString().split("1").length - 1;
    },
    format_coordinates(lat, lng) {
      return `${lat}, ${lng}`;
    },
    format_suffix(value, suffix) {
      return `${value} ${suffix}`;
    },
    format_device_details() {
      const transformerCoordinates = this.format_coordinates(
        this.device_details["CurrentLat"],
        this.device_details["CurrentLng"]
      );
      const feedersConnected = this.get_active_feeders(this.device_details["ActiverFeeders"]);
      const transformerRating = this.format_suffix(this.device_details["TransformerRating"], "kW");
      return (this.device_details = {
        ...this.device_details,
        TransformerLocation: "Dublin", // Ask this as it is not in the data
        TransformerCoordinates: transformerCoordinates,
        TransformerRating: transformerRating,
        FeedersConnected: feedersConnected,
        AreaRating: "A-", // Ask this as it is not in the data
      });
    },
  },
  computed: {
    final_recepient: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let recepients = "";
          let total = this.recipients_list.length;
          let limit = total > 7 ? 7 : total;
          for (var i = 0; i < limit; i++) {
            recepients = recepients
              ? recepients + "; " + this.recipients_list[i]["RecipientEmail"]
              : this.recipients_list[i]["RecipientEmail"];
          }
          return recepients;
        }
        return this.recepient;
      }
      return this.recepient;
    },
    recipients_number: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let total = this.recipients_list.length;
          return total > 7 ? total - 7 : null;
        }
        return null;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.blur-wrapper {
  position: relative;
}

.title-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  font-weight: bold;
  color: var(--v-primary-base);
  z-index: 1;
}

.blur {
  /* Blur Effect */
  filter: blur(8px);
  pointer-events: none;
  user-select: none;
  padding: 20px;
  border-radius: 8px;
}
</style>
